import PropTypes from 'prop-types'

const AnalyticsCard = ({ title, value, icon }) => (
  <div className="analytics-card">
    <span>
      {icon}
      {title}
    </span>
    <span>{value || 0}</span>
  </div>
)

AnalyticsCard.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.node,
}

export default AnalyticsCard
